
export interface RvlParameters {
    rvlMacAddr: string;
    rvlIpAddr: string;
    rvlPort: number;
    rvlIpIncrement: boolean;
    rvlPortMode: string;
    rvlAutoStartMode: string;
    rvlAutoVariants: string;
    rvlPidCC: boolean;
}

export interface EventParameters {
    startTime: number;
    duration: number;
    startWindow: number;
}

export type MonitorMode = 0 | 1 | 2 | 3 | 4 | 'All Segments' | 'Header Only' | 'Sample' | 'VOD' | 'Dynamic Ad';

// tslint:disable-next-line:interface-name
export interface IAsset {
    id ?: number;
    name: string;
    streamType: string;
    assetName: string;
    profiles: string;
    template: string;
    url: string;
    misc: string;
    setMembership?: string;
    lowLatency?: boolean;
    autoStartOnReset?: boolean;
    qoeVideo?: boolean;
    qoeAudio?: boolean;
    qoePixel?: boolean;
    contentValidation: boolean;
    cdnCacheMeasurements: boolean;
    decryptDrmBypass: boolean;
    mediaHostSubst: string;
    mediaPathSubst: string;
    keyHostSubst: string;
    keyPathSubst: string;
    indexHostSubst: string;
    indexPathSubst: string;
    monitorMode?: MonitorMode;
    userAgent: string;
    hostReqHdrPri: string;
    hostReqHdrSec: string;
    tokens: string;
    variants: string | number[];
    rvl?: RvlParameters;
    modified: boolean;
    mimeHdrExt: string;
    decryptMode: string;
    decryptContentId: string;
    decryptStaticKey: string;
    decryptStaticIv: string;
    schedule?: EventParameters;
    dashQoEAudioSubRep: boolean;
    headerModified: boolean;
    variantModified: boolean;

}

export interface VodAlias {
    fileMode: 'ALL' | 'PARTIAL BLOCKS' | 'ADVANCE' | 'EXPIRED';
    timeMode: 'NORMAL' | 'ADVANCE';
    requestType: 'GET' | 'HEAD';
    fileAdvance?: number;
    timeAdvance?: number;
    duration: string;       // 00:00:00
}

export default class Asset implements IAsset {
    id ?: number;
    name: string;
    streamType: string;
    assetName: string;
    profiles: string;
    template: string;
    url: string;
    misc: string;
    qoeVideo?: boolean;
    qoeAudio?: boolean;
    qoePixel?: boolean;
    setMembership?: string;
    lowLatency?: boolean;
    autoStartOnReset?: boolean;
    contentValidation: boolean;
    cdnCacheMeasurements: boolean;
    decryptDrmBypass: boolean;
    mediaHostSubst: string;
    mediaPathSubst: string;
    keyHostSubst: string;
    keyPathSubst: string;
    indexHostSubst: string;
    indexPathSubst: string;
    monitorMode?:  MonitorMode;
    userAgent: string;
    hostReqHdrPri: string;
    hostReqHdrSec: string;
    tokens: string;
    variants: string;
    rvl: RvlParameters;
    vod?: VodAlias;
    modified: boolean;
    qoeVideoVariants: string;
    qoeAudioVariants: string;
    qoePixelVariants: string;
    daiEnable: boolean;
    daiTemplate: string;
    mimeHdrExt: string;
    decryptMode: string;
    decryptContentId: string;
    decryptStaticKey: string;
    decryptStaticIv: string;
    schedule: EventParameters;
    dashQoEAudioSubRep: boolean;
    headerModified: boolean;
    variantModified: boolean;

    public static VodAsset() {
        let asset = new Asset();
        asset.vod = {
            fileMode: 'ALL',
            timeMode: 'NORMAL',
            requestType: 'GET',
            fileAdvance: 0,
            timeAdvance: 0,
            duration: '0:00:00'
        };
        return asset;
    }

    public static RvlAsset(setMembership ?: string) {
        let asset = new Asset();

        asset.setMembership = setMembership;
        asset.autoStartOnReset = false;
        asset.rvl = {
            rvlMacAddr: '00:00:00:00:00:00',
            rvlIpAddr: '0.0.0.0',
            rvlPort: 0,
            rvlIpIncrement: false,
            rvlPortMode: 'Fixed',
            rvlAutoStartMode: 'Disable',
            rvlAutoVariants: '',
            rvlPidCC: false
        };
        return asset;
    }

    public static EventAsset(setMembership ?: string) {
        let asset = new Asset();

        asset.setMembership = setMembership;
        asset.autoStartOnReset = false;
        asset.rvl = {
            rvlMacAddr: '00:00:00:00:00:00',
            rvlIpAddr: '0.0.0.0',
            rvlPort: 0,
            rvlIpIncrement: false,
            rvlPortMode: 'Fixed',
            rvlAutoStartMode: 'Disable',
            rvlAutoVariants: '',
            rvlPidCC: false
        };
        asset.schedule = {
            startTime: 0,
            duration: 30,
            startWindow: 5
        };
        return asset;
    }

    constructor() {
        this.id = undefined;
        this.name = '';
        this.streamType = 'HLS Master';
        this.assetName = '';
        this.profiles = '';
        this.template = 'streamDefault';
        this.url = '';
        this.misc = '';
        this.qoeVideo = false;
        this.qoeAudio = false;
        this.qoePixel = false;
        this.contentValidation = false;
        this.cdnCacheMeasurements = false;
        this.decryptDrmBypass = false;
        this.mediaHostSubst = '';
        this.mediaPathSubst = '';
        this.keyHostSubst = '';
        this.keyPathSubst = '';
        this.indexHostSubst = '';
        this.indexPathSubst = '';
        this.monitorMode = 'All Segments';
        this.userAgent = '';
        this.hostReqHdrPri = '';
        this.hostReqHdrSec = '';
        this.tokens = '';
        this.variants = '';
        this.modified = false;
        this.qoeVideoVariants = '';
        this.qoeAudioVariants = '';
        this.qoePixelVariants = '';
        this.daiEnable = false;
        this.daiTemplate = '';
        this.mimeHdrExt = '';
        this.decryptMode = 'Disabled';
        this.decryptContentId = '';
        this.decryptStaticKey = '';
        this.decryptStaticIv = '';
        this.dashQoEAudioSubRep = false;
        this.headerModified = false;
        this.variantModified = false;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/models/asset.tsx